import React from 'react';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { Box } from '@mui/material';
import { useToggleModal } from '@hooks';
import { ModalFormSection } from 'components/common/modals';
import { ModalV2 } from 'components/common/modals/ModalV2';

import uploadInputStyles from 'components/common/media/UploadInput/uploadInput.style';
import InstaTaskUploadDocumentForm from './InstaTaskUploadDocumentForm';

const InstaTaskUploadDocument = ({ documentsType, onSubmit, isLoading }) => {
  const { isOpen, handleClose, handleOpen } = useToggleModal();

  const handleSubmit = async (values) => {
    await onSubmit(values);
    handleClose();
  };

  return (
    <>
      <Box
        onClick={handleOpen}
        sx={{
          cursor: 'pointer',
          ...uploadInputStyles.uploadArea,
          ...uploadInputStyles?.uploadAreaWithBackGround?.(),
        }}
      >
        <>
          <InsertDriveFileIcon
            data-testid="InsertDriveFileIcon"
            sx={uploadInputStyles.icon}
          />
          <Box sx={uploadInputStyles.uploadAreaText}>
            Επίλεξε τα αρχεία που θες να ανεβάσεις
          </Box>
        </>
      </Box>
      <Box
        sx={{ cursor: 'pointer', ...uploadInputStyles.uploadAreaIcon }}
        onClick={handleOpen}
      />
      <ModalV2
        id="add-new-document-modal"
        title="Upload New Document"
        isOpen={isOpen}
        size="sm"
        maxWidth="sm"
        onClose={handleClose}
      >
        <ModalFormSection>
          <InstaTaskUploadDocumentForm
            onSubmit={handleSubmit}
            onCancel={handleClose}
            isLoading={isLoading}
            documentsType={documentsType}
          />
        </ModalFormSection>
      </ModalV2>
    </>
  );
};

export default InstaTaskUploadDocument;
